import { TabBar } from 'antd-mobile'
import {
  ContentOutline,
  FileOutline,
  HeartOutline,
  SetOutline,
} from 'antd-mobile-icons'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { isProduction } from '@/types/api'

const baseTabs = [
  {
    key: '/courses',
    title: '课程',
    icon: <ContentOutline />,
  },
  {
    key: '/favorites',
    title: '收藏',
    icon: <HeartOutline />,
  },
  {
    key: '/order',
    title: '我的订单',
    icon: <FileOutline />,
  },
]

const tabs = isProduction()
  ? baseTabs
  : [
      ...baseTabs,
      {
        key: '/test',
        title: '测试',
        icon: <SetOutline />,
      },
    ]

export default function BottomTabBar() {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div
      className="fixed bottom-0 left-0 right-0 mx-[auto]  w-[100%] z-50 bg-white border-[1px] border-[#F2F3F5] border-t-0"
      hidden={!tabs.some((tab) => tab.key === location.pathname)}
    >
      <TabBar
        activeKey={location.pathname}
        onChange={(key) => {
          navigate({ to: key, replace: true })
        }}
      >
        {tabs.map((item) => (
          <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
        ))}
      </TabBar>
    </div>
  )
}
